import { useQuery, UseQueryResult } from '@tanstack/react-query';
import csReviewApi from '../../../../../../lib/api/cs/review/CsReviewApi';
import { TAG } from '../../../../../../constants/queryKeys';
import { TagProductRelatedFindBodyRequestDto, TagProductRelatedFindBodyResponseDto } from '../../types/TagListTypes';
import { QueryOptions } from '../../../../../../types/query/useQuery';
import { setRequestForm } from '../../../../../../lib/common';

type UseProductTagListQuery<SelectResultType> = {
  payload: TagProductRelatedFindBodyRequestDto;
  options?: QueryOptions<TagProductRelatedFindBodyResponseDto, unknown, SelectResultType>;
};

export const useProductTagListQuery = <SelectResultType>({
  payload,
  options,
}: UseProductTagListQuery<SelectResultType>): UseQueryResult<SelectResultType, unknown> => {
  return useQuery<TagProductRelatedFindBodyResponseDto, unknown, SelectResultType>(
    [...TAG.PRODUCT, payload],
    () => csReviewApi.getProductTagList(setRequestForm(payload)),
    {
      ...options,
      suspense: true,
      enabled: !!payload.productId,
    },
  );
};
